import { render } from "./Factuur.vue?vue&type=template&id=048c594c&scoped=true&ts=true"
import script from "./Factuur.vue?vue&type=script&lang=ts"
export * from "./Factuur.vue?vue&type=script&lang=ts"

import "./Factuur.vue?vue&type=style&index=0&id=048c594c&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048c594c"]])

export default __exports__